import template from "./account-activity-adujdication.html"

ko.components.register('account-activity-adjudication', {
    template: template,
    viewModel: {
        createViewModel: function (params, componentInfo, widgetInfo) {
            return new AdjudicationInfo(params, widgetInfo);
        }
    }
});

export class AdjudicationInfo {
    constructor(params, widgetInfo) {
        const activity = params.model;
        let model = activity.ClaimAdjudicationDetails;

        if (!model && activity.IsCardTransaction && activity.CardTransactionDetails) {
            model = {
                ApprovedAmount: activity.CardTransactionDetails.ApprovedAmount,
                EligibleAmount: activity.CardTransactionDetails.ApprovedAmount,
                ExcludedAmount: activity.CardTransactionDetails.IneligibleAmount,
                ExcludedReason: activity.CardTransactionDetails.IneligibleReason
            };
        }
        
        this.isExist = !!model;
        this.approved = model?.ApprovedAmount;
        this.deductible = model?.DeductibleAmount;
        this.denied = model?.DeniedAmount;
        this.eligible = model?.EligibleAmount;
        this.excluded = model?.ExcludedAmount;
        this.lowFunds = model?.LowFundsAmount;
        this.offset = model?.OffsetAmount;
        this.onHold = model?.OnHoldAmount;
        this.pended = model?.PendedAmount;
        this.excludedReason = model?.ExcludedReason;
        this.pendedComment = params.model.PendedComment;
        this.denialComment = params.model.DenialComment;
        this.notes = params.model.Notes;
        this.pendedReason = params.model.PendedReason;
        this.denialReason = params.model.DenialReason;
        this.isOnHold = params.model.isOnHold;

        this.valueClass = params.valueClass;
    }
}